import {Outlet} from 'react-router-dom';

const AnalysisLayout = () => {
  return(
    <div>
      <div>
        <Outlet/>
      </div>
    </div>
  )
}

export default AnalysisLayout;


